import React from 'react'
import Form from '@rjsf/mui'
import validator from '@rjsf/validator-ajv8'
import axios from 'axios'
import Typography from '@mui/material/Typography'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import { useParams } from 'react-router-dom'
import { JSONSchema7 } from 'json-schema'
import ButtonDialog from '../shared/ButtonDialog'
import { CreateProps } from '../shared/CreateProps'
import AddIcon from '@mui/icons-material/AddCircleOutline'
import ScenarioIcon from '@mui/icons-material/Tune'
import { useAuth } from '../../context/useAuth'

export default function CreateScenario({ disabled, schema, setData }: CreateProps) {
  const { name } = useParams()
  const { csrf, simulation } = useAuth()
  const [open, setOpen] = React.useState(false)

  const checkAddScenario = () => {
    if (
      (simulation?.battery && Object.keys(simulation.battery).length > 0) ||
      (simulation?.pvinstallation && Object.keys(simulation.pvinstallation).length > 0)
    )
      return true
  }

  const getDialogContent = () => {
    return checkAddScenario() ? (
      <Form
        showErrorList={false}
        transformErrors={(errors: any) => {
          return errors.map((error: any) => {
            if (error.name === 'pattern') error.message = 'Invalid name'
            return error
          })
        }}
        onSubmit={async (e) => {
          try {
            const res = await axios.post(`${process.env.REACT_APP_API}/${name}/scenario`, JSON.stringify(e.formData), {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': csrf,
              },
              withCredentials: true,
            })
            setData(res.data)
            setOpen(false)
          } catch (err: any) {
            window.alert(err.response.data.error)
          }
        }}
        validator={validator}
        schema={schema as JSONSchema7}
      />
    ) : (
      <>
        <Typography variant='body2'>
          In order to create a scenario, you need to configure at least 1 battery or pvinstallation in the main
          configuration of this simulation.
        </Typography>
        <DialogActions sx={{ p: 0, pt: 2 }}>
          <Button onClick={() => setOpen(false)}>Ok</Button>
        </DialogActions>
      </>
    )
  }

  return (
    <ButtonDialog
      disabled={disabled}
      title={`Add Scenario`}
      icon={<ScenarioIcon />}
      iconButton={<AddIcon fontSize='small' color={disabled ? 'disabled' : 'primary'} />}
      content={getDialogContent()}
      open={open}
      setOpen={setOpen}
    />
  )
}
